export const config = {
    namespaced: true,
    state: {
        customer: false,
        location: false
    },
    actions: {
        change({ commit }, data) {
            commit('changeState', data);
        }
    },
    mutations: {
        changeState(state, data) {
            state.customer = data.customer;
            state.location = data.location;
        }
    },
    getters: {
        showCustomer(state) {
            return state.customer;
        },
        showLocation(state) {
            return state.location;
        }
    }
}
